import React from 'react';
import { ClockIcon } from 'lucide-react';
import { GENERAL_ENQUIRY_URL } from '../../utils/whatsapp';
import { trackAddToCart } from '../../utils/metaPixel';
export function UrgencyBanner() {
  return <div className="bg-navy" data-id="element-32" data-mp="1raztppcbc37v">
      <div className="mx-auto flex max-w-7xl justify-center px-5 py-2.5 sm:px-8" data-id="element-33" data-mp="1ra7yifmmo7i4">
        <a href={GENERAL_ENQUIRY_URL} target="_blank" rel="noreferrer" onClick={() => trackAddToCart({
        contentName: 'Banner de urgencia'
      })} className="shine-sweep group relative inline-flex items-center gap-2 overflow-hidden rounded-full border border-lime/40 bg-navy-soft px-5 py-2 text-center text-[11px] font-bold uppercase tracking-wide text-ivory shadow-pop transition-colors duration-200 ease-smooth hover:border-lime focus:outline-none focus-visible:ring-2 focus-visible:ring-lime sm:text-xs" data-id="element-34" data-mp="1mbwnw2oidsyu">
          <ClockIcon className="h-3.5 w-3.5 shrink-0 text-lime" aria-hidden="true" data-id="element-35" data-mp="uls9cknfk05j" />
          Aproveche la promoción por tiempo limitado
        </a>
      </div>
    </div>;
}